"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var CrudSimple = __importStar(require("../../../../crud-simple"));
var data_1 = __importDefault(require("../../../interface/workflow/data"));
var logs_1 = __importDefault(require("./logs"));
var extra = function (urlPrefix, withBackend) { return [
    {
        tab: 'States',
        width: { xs: 12, sm: 12, md: 12, lg: 12 },
        Component: function (uuid) { return (react_1["default"].createElement(logs_1["default"], { urlPrefix: urlPrefix, uuid: String(uuid), withBackend: withBackend })); }
    }
]; };
var WorkflowApp = function (_a) {
    var urlPrefix = _a.urlPrefix, withBackend = _a.withBackend;
    var dataDef = {
        urlPrefix: urlPrefix,
        detailUrlPrefix: 'workflow',
        displayType: { add: false, editType: 'view', "delete": false },
        fields: [{ name: 'name', label: 'Name', type: 'string' }],
        paper: { list: false, detail: false },
        listConfig: { nPerPage: 10 }
    };
    return (react_1["default"].createElement(CrudSimple.Generic.App, { dataDef: dataDef, Data: new data_1["default"](withBackend), extra: extra(urlPrefix + "/workflow", withBackend) }));
};
exports["default"] = WorkflowApp;
